// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YXECq","badges":"styles_badges__1U2i4"};